import React from 'react';
import { CodeBracketIcon, CloudIcon } from '@heroicons/react/24/outline';

const skills = [
  {name:'Angular (standalone) / Material', icon: <CodeBracketIcon className="w-6 h-6" />},
  {name:'HTML5 / CSS3 / SCSS', icon: <CodeBracketIcon className="w-6 h-6" />},
  {name:'TypeScript', icon: <CodeBracketIcon className="w-6 h-6" />},
  {name:'Tailwind CSS / Responsive', icon: <CodeBracketIcon className="w-6 h-6" />},
  {name:'Python (Flask / FastAPI)', icon: <CodeBracketIcon className="w-6 h-6" />},
  {name:'AWS Lambda / Serverless', icon: <CloudIcon className="w-6 h-6" />},
  {name:'SonarCloud / Seguridad', icon: <CodeBracketIcon className="w-6 h-6" />},
  {name:'APIs REST / Documentación', icon: <CodeBracketIcon className="w-6 h-6" />},
];

const Skills = () => {
  return (
    <section id="skills" aria-label="Habilidades">
      <h2 className="text-2xl font-poppins mb-4">Habilidades</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {skills.map((s, i) => (
          <div key={i} className="p-4 rounded-lg border hover:scale-105 transition" role="button" tabIndex={0} aria-label={s.name} title={s.name}>
            <div className="flex items-center gap-3">
              <div className="p-2 bg-gray-100 rounded">{s.icon}</div>
              <div className="font-medium">{s.name}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Skills;
